import { render, staticRenderFns } from "./rtCard.vue?vue&type=template&id=b6c256f4&scoped=true"
import script from "./rtCard.vue?vue&type=script&lang=js"
export * from "./rtCard.vue?vue&type=script&lang=js"
import style0 from "./rtCard.vue?vue&type=style&index=0&id=b6c256f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c256f4",
  null
  
)

export default component.exports